// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__38nkU","approved":"Status_approved__1poNQ","rejected":"Status_rejected__2P_wW","expired":"Status_expired__19GO3","label":"Status_label__3AkOz"};